import { ActionContext, createStore, Store } from 'vuex';
export interface LoaderStoreVuex {
    load: boolean
}
export const LoaderStore: Store<LoaderStoreVuex> = createStore({
    state: {
        load: false
    },
    mutations: {
        setLoad(state: LoaderStoreVuex, load: boolean) {
            state.load = load;
        }
    },
    actions: {
        async load(context: ActionContext<LoaderStoreVuex, LoaderStoreVuex>) {
            context.commit('setLoad', true);
        },
        async done(context: ActionContext<LoaderStoreVuex, LoaderStoreVuex>) {
            context.commit('setLoad', false);
        }
    }
});
